export function createMessage(context, record) {
  context.gateways.messageGateway.sendMessage(record);
}

export function updateWelcomeMessage(context, record) {
  context.gateways.messageGateway.updateWelcomeMessage(record);
}

export function updateCustomerUrl(context, record) {
  context.gateways.messageGateway.updateCustomerUrl(record);
}

export function updateCustomerTypingState(context, record) {
  context.gateways.messageGateway.updateCustomerTypingState(record);
}
